/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   commerce\client\webapi\clientgeneratorconfigs\genclient.json
 */

"use strict";

import VSS_Commerce_Contracts = require("VSS/Commerce/Contracts");
import VSS_Service = require("VSS/Service");
import VSS_WebApi = require("VSS/WebApi/RestClient");

export class CommonMethods4_1To7_2 extends VSS_WebApi.VssHttpClient {

    public static serviceInstanceId = "00000047-0000-8888-8000-000000000000";
    protected purchaseRequestApiVersion: string;

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
    }

    /**
     * [Preview API]
     *
     * @param {VSS_Commerce_Contracts.PurchaseRequest} request
     * @return IPromise<void>
     */
    public updatePurchaseRequest(
        request: VSS_Commerce_Contracts.PurchaseRequest
        ): IPromise<void> {

        return this._beginRequest<void>({
            httpMethod: "PATCH",
            httpResponseType: "html",
            area: "PurchaseRequest",
            locationId: "6f905b2d-292a-4d30-b38a-2d254eab06b7",
            resource: "PurchaseRequest",
            routeTemplate: "_apis/{area}/{resource}",
            requestType: VSS_Commerce_Contracts.TypeInfo.PurchaseRequest,
            apiVersion: this.purchaseRequestApiVersion,
            data: request
        });
    }

    /**
     * [Preview API]
     *
     * @param {VSS_Commerce_Contracts.PurchaseRequest} request
     * @return IPromise<void>
     */
    public createPurchaseRequest(
        request: VSS_Commerce_Contracts.PurchaseRequest
        ): IPromise<void> {

        return this._beginRequest<void>({
            httpMethod: "PUT",
            httpResponseType: "html",
            area: "PurchaseRequest",
            locationId: "6f905b2d-292a-4d30-b38a-2d254eab06b7",
            resource: "PurchaseRequest",
            routeTemplate: "_apis/{area}/{resource}",
            requestType: VSS_Commerce_Contracts.TypeInfo.PurchaseRequest,
            apiVersion: this.purchaseRequestApiVersion,
            data: request
        });
    }
}

/**
 * @exemptedapi
 */
export class PurchaseRequestHttpClient7_2 extends CommonMethods4_1To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.purchaseRequestApiVersion = "7.2-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class PurchaseRequestHttpClient7_1 extends CommonMethods4_1To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.purchaseRequestApiVersion = "7.1-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class PurchaseRequestHttpClient7 extends CommonMethods4_1To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.purchaseRequestApiVersion = "7.0-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class PurchaseRequestHttpClient6_1 extends CommonMethods4_1To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.purchaseRequestApiVersion = "6.1-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class PurchaseRequestHttpClient6 extends CommonMethods4_1To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.purchaseRequestApiVersion = "6.0-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class PurchaseRequestHttpClient5_2 extends CommonMethods4_1To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.purchaseRequestApiVersion = "5.2-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class PurchaseRequestHttpClient5_1 extends CommonMethods4_1To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.purchaseRequestApiVersion = "5.1-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class PurchaseRequestHttpClient5 extends CommonMethods4_1To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.purchaseRequestApiVersion = "5.0-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class PurchaseRequestHttpClient4_1 extends CommonMethods4_1To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.purchaseRequestApiVersion = "4.1-preview.1";
    }
}

export class PurchaseRequestHttpClient extends PurchaseRequestHttpClient7_2 {
    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
    }
}

const clientMapping: { [id: string]: new (routeRequestPath: string) => VSS_WebApi.VssHttpClient; } = {
    "7.2": PurchaseRequestHttpClient7_2,
    "7.1": PurchaseRequestHttpClient7_1,
    "7.0": PurchaseRequestHttpClient7,
    "6.1": PurchaseRequestHttpClient6_1,
    "6.0": PurchaseRequestHttpClient6,
    "5.2": PurchaseRequestHttpClient5_2,
    "5.1": PurchaseRequestHttpClient5_1,
    "5.0": PurchaseRequestHttpClient5,
    "4.1": PurchaseRequestHttpClient4_1
}

/**
 * Gets an http client targeting the latest released version of the APIs.
 *
 * @return PurchaseRequestHttpClient7_1
 */
export function getClient(options?: VSS_WebApi.IVssHttpClientOptions): PurchaseRequestHttpClient7_1 {
    if ((<any>window).VSS && (<any>window).VSS.VssSDKRestVersion && clientMapping[(<any>window).VSS.VssSDKRestVersion]) {
        return VSS_Service.getClient<PurchaseRequestHttpClient7_1>(<any>(clientMapping[(<any>window).VSS.VssSDKRestVersion]), undefined, undefined, undefined, options);
    }
    else {
        return VSS_Service.getClient<PurchaseRequestHttpClient7_1>(PurchaseRequestHttpClient7_1, undefined, undefined, undefined, options);
    }
}
